import View from './View'

const Container = ({ uuId, data}) => {
  return <View title="Single Fatura" uuId={uuId} data={data} />
}

export default Container
